<div id="monthly-expenses-main-container" class="page-layout blank">
    <div class="content">
        <div class="left">

            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <div class="widget" fxFlex="100" fxFlex.gt-sm="100">
                <div class="fuse-card auto-width m-12 mat-card mat-elevation-z2 p-0" [ngClass.gt-sm]="'mb-0 p-0 m-b-6'">
                    <div class="p-t-15  p-l-20 h3">Gastos Mensuales</div>
                    <app-expenses-list></app-expenses-list>
                </div>
            </div>
        </div>
        </div>
    </div>
</div> 